import { motion } from "framer-motion";

export default function Button(props) {
    
    const offset = props.height * 0.1;

    const borderRadius = props.borderRadius;

    const color = props.color;
    const secondaryColor = props.secondaryColor;

    const text = props.text;

    const isTapped = props.isTapped;
    const disabled = props.disabled;

    const onClick = props.onClick;

    return (
        <div class="button"
            disabled={disabled}
        >
            <div class="button-bottom"
                
            ></div>
            <div className="button-top"
                onClick={() => onClick()}
            >
                {text}
            </div>
        </div>
    )
}